import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(localizedFormat);

export default function (value) {
  try {
    return dayjs.unix(value).format("L");
  } catch (error) {
    console.error("DateFilter ERROR: ", error);
    return "";
  }
}
